import { getQueryString } from "@/utils/url";
import thinkingdata from './thinkingdata.esm.min';

const channel = getQueryString("utm_source")
const appId = "206145a2454e4029b54d0555e5df28c3";

export const track = {
  baseConfig: {
    appId,
    serverUrl: "https://ta.seayoo.com",
    showLog: false,
  },
  commonTrackInfo: {
    utm_source: channel || "original",
    page_id: "pre_register",
  },
  init: function () {
    thinkingdata.init({ ...this.baseConfig });
  },
  trackPageView(params = {}) {
    thinkingdata.track("web_page_view", {
      ...this.commonTrackInfo,
      ...params,
    });
  },
  trackWebModuleClick(params = {}) {
    thinkingdata.track("web_module_click", {
      ...this.commonTrackInfo,
      ...params,
    });
  },
  trackPreRegister(params = {}) {
    thinkingdata.track("pre_register", {
      ...this.commonTrackInfo,
      ...params,
    });
  },
  trackDownloadPageView(params = {}) {
    thinkingdata.track("web_page_view", {
      utm_source: channel || "original",
      page_id: "download",
      ...params,
    });
  }
};
